import { BookOpen, Music, Tv } from "lucide-react";

export const TYPE_ORDER = ["anime", "movie", "music", "book"];

export const TYPE_STYLES = {
  anime: {
    icon: Tv,
    color: "#C97A4A",
    bg: "#FBEDE3",
    label: "Anime",
  },
  movie: {
    icon: Tv,
    color: "#6A5ACD",
    bg: "#ECE9FF",
    label: "Movie",
  },
  music: {
    icon: Music,
    color: "#3F6B5E",
    bg: "#E7F0EC",
    label: "Music",
  },
  book: {
    icon: BookOpen,
    color: "#8B5E3C",
    bg: "#F5ECE3",
    label: "Book",
  },
};

export const STATUS_OPTIONS = {
  anime: [
    { label: "Recommended", color: "#7C3AED", bg: "#EDE9FE", emoji: "✨" },
    { label: "Want to Watch", color: "#D97706", bg: "#FEF3C7", emoji: "📺" },
    { label: "Watching", color: "#2563EB", bg: "#DBEAFE", emoji: "👀" },
    { label: "Completed", color: "#16A34A", bg: "#DCFCE7", emoji: "✅" },
  ],
  movie: [
    { label: "Recommended", color: "#7C3AED", bg: "#EDE9FE", emoji: "✨" },
    { label: "Want to Watch", color: "#D97706", bg: "#FEF3C7", emoji: "🎬" },
    { label: "Watching", color: "#2563EB", bg: "#DBEAFE", emoji: "👀" },
    { label: "Watched", color: "#16A34A", bg: "#DCFCE7", emoji: "🍿" },
  ],
  music: [
    { label: "Recommended", color: "#7C3AED", bg: "#EDE9FE", emoji: "🎧" },
    { label: "Liked", color: "#2563EB", bg: "#DBEAFE", emoji: "💙" },
    { label: "Favorite", color: "#DC2626", bg: "#FEE2E2", emoji: "❤️" },
  ],
  book: [
    { label: "Recommended", color: "#7C3AED", bg: "#EDE9FE", emoji: "✨" },
    { label: "Want to Read", color: "#D97706", bg: "#FEF3C7", emoji: "📚" },
    { label: "Reading", color: "#2563EB", bg: "#DBEAFE", emoji: "📖" },
    { label: "Finished", color: "#16A34A", bg: "#DCFCE7", emoji: "✔️" },
  ],
};

export const EXTRA_FIELDS = {
  anime: [
    { name: "studio", placeholder: "Studio (optional)" },
    { name: "episodes", placeholder: "Episodes (optional)" },
  ],
  movie: [
    { name: "director", placeholder: "Director (optional)" },
    { name: "runtime", placeholder: "Runtime (optional)" },
  ],
  music: [
    { name: "artist", placeholder: "Artist" },
    { name: "album", placeholder: "Album (optional)" },
  ],
  book: [
    { name: "author", placeholder: "Author (optional)" },
    { name: "pages", placeholder: "Pages (optional)" },
  ],
};

export const TITLE_PLACEHOLDERS = {
  anime: "Anime title",
  movie: "Movie title",
  music: "Song title",
  book: "Book title",
};

// Status buckets, shared by Tracker, Stats and Profile so the four figures
// (Total / In Progress / Completed / Planned) always agree across screens.
export const DONE_STATUSES = ["Finished", "Watched", "Completed"];

export const PLANNED_STATUSES = [
  "Recommended",
  "Want to Watch",
  "Want to Read",
  "Liked",
];

export const DEFAULT_TYPE = "anime";

export const EMPTY_DRAFT = {
  type: DEFAULT_TYPE,
  title: "",
  rating: 3,
  status: STATUS_OPTIONS[DEFAULT_TYPE][0].label,
  studio: "",
  episodes: "",
  director: "",
  runtime: "",
  artist: "",
  album: "",
  author: "",
  pages: "",
  tags: "",
  note: "",
};
